import {Component, Input, Output, EventEmitter} from 'ng-metadata/core';
import {StaticService } from './static.service';



@Component({
    selector: 'prm-static',
    template : '<div ng-include="$ctrl.getTemplateUrl()" onload="$ctrl.templateIncludedEventCall()"></div>',
})


export class PrmStatic{

    @Input() section:string;
    @Input() public parentCtrl:any;
    @Output() templateIncludedEvent = new EventEmitter<void>();

    constructor(private staticService: StaticService) {
    }

    public getTemplateUrl() {
        return this.staticService.getTemplateUrl(this.section);
    }

    public templateIncludedEventCall() {
        return this.templateIncludedEvent.emit();
    }


}


// WEBPACK FOOTER //
// ./src/main/webapp/components/static/static.directive.ts